var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 589,
    height: 589,
    viewBox: "0 0 589 589",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "black",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "     M281 0H308L589 278V307L308 589H281L0 307V278L281 0Z     M550.177 282.5H447.788L416.295 249.991L468.99 199.71L550.177 282.5Z     M280.5 39.7988V145.211L193.992 229.706L142.295 176.995L280.5 39.7988Z     M170 250L146 278H43L121 200L170 250Z     M447.708 179.006L308.5 36.7803V143.787L395.997 228.302L447.708 179.006Z     M173.704 338.997L143.207 308.5H41.8242L121.997 391.718L173.704 338.997Z     M193.348 360.641L141.288 410.998L281.5 550.201V445.788L193.348 360.641Z     M447.697 412.01L395.993 358.722L308.5 446.796V551.207L447.697 412.01Z     M465.996 390.703L415.287 339.994L448.798 307.5H551.228L465.996 390.703Z     M419.707 293.991L293.999 171.3L169.296 293.991L293.999 422.717L419.707 293.991Z     M339 293C339 317.853 318.853 338 294 338C269.147 338 249 317.853 249 293C249 268.147 269.147 248 294 248C318.853 248 339 268.147 339 293Z   "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.2abd4aa7ccf071d68c31ede7ac19e78d.svg";
export { ForwardRef as ReactComponent };